import { Workflow } from "@/pages/Messaging/Workflows/types";
import React from "react";
export const WorkflowContext = React.createContext<{
  workflow: Workflow | null;
}>({
  workflow: null
});
